export default __webpack_public_path__ + "static/media/Mark-3-HUD-13.4299022e.jpg";